import { Box, useMediaQuery, useTheme } from "@mui/material";
import { Card, MoneyRecive } from "iconsax-react";
import { useTranslation } from "react-i18next";

import { CreateShopStepHeading, FloatingTextField } from "@/components/Molecules";
import type { CreateShopPayoutStepProps } from "./CreateShopPayoutStep.types";
import * as styles from "./CreateShopPayoutStep.styles";

export function CreateShopPayoutStep({ infoForm, commissionRateLabel }: CreateShopPayoutStepProps) {
  const { t } = useTranslation("shops");
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const iconSize = isDesktop ? 19 : 17;
  const ibanError = infoForm.formState.errors.iban?.message;

  return (
    <>
      <CreateShopStepHeading
        titleKey="create.payout.title"
        subtitleKey="create.payout.subtitle"
        mobileSubtitleKey="create.payout.mobileSubtitle"
        values={{ rate: commissionRateLabel }}
      />

      <Box sx={styles.plans}>
        <Box sx={styles.banner}>
          <MoneyRecive size={iconSize} variant="Bold" color={theme.palette.success.main} />
          <Box component="span" sx={styles.text}>
            {t("create.payout.online")}
          </Box>
        </Box>
        <Box sx={styles.banner}>
          <Card size={iconSize} variant="Bold" color={theme.palette.warning.main} />
          <Box component="span" sx={styles.text}>
            {t("create.payout.offline")}
          </Box>
        </Box>
      </Box>

      <FloatingTextField
        label={t("create.payout.iban")}
        placeholder="IR000000000000000000000000"
        error={Boolean(ibanError)}
        helperText={ibanError ?? t("create.payout.ibanHelper")}
        slotProps={{ htmlInput: { dir: "ltr", maxLength: 32 } }}
        {...infoForm.register("iban")}
      />
    </>
  );
}
